import { ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import { getErrorStatus, getOperationCode } from 'store/selectors'
import { disableMixPanelTracking } from '../disable'

export const mapStateToMPEvent = (eventName, state) => ({ // (eventName: string, state: State)
  'Error Code': getErrorStatus(state),
  'Error Name': 'Network Error',
  'Event Name': eventName,
  'Operation Code': getOperationCode(state),
  'Page Name': 'Sign In'
})

/*
** Handles the same error as src/App/Main/Error/Network
*/
const memberErrorEpic = (actions$, state$) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.errors.NETWORK_ERROR),
  tap((action) => { // (action: NetworkErrorAction)
    const eventName = 'Member Error'

    track(eventName, mapStateToMPEvent(eventName, state$.value), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default memberErrorEpic
